import { getDay } from "date-fns";
import { filterHolidayDates, ShowroomLocation } from "shared/utils/date";

const useFilterCalendarDates = () => {
  // This function filters the pick-up ESD method dates based on specific conditions
  const filterPickUpEsdMethodDates = (date: Date): boolean => {
    const day = getDay(date);
    // Exclude Sundays and Saturdays from the available dates
    return day !== 0 && filterHolidayDates(date, ShowroomLocation.Vlaardingen);
  };

  // This function filters the pick-up VillaArena method dates based on specific conditions
  const filterPickUpVillaArenaMethodDates = (date: Date): boolean => {
    // Exclude holidays from the available dates
    return filterHolidayDates(date, ShowroomLocation.Amsterdam);
  };
  return { filterPickUpEsdMethodDates, filterPickUpVillaArenaMethodDates };
};

export default useFilterCalendarDates;
